module.exports = __webpack_public_path__ + "img/gw1.a4a2f7a2.png";